import React,{memo} from 'react'
import { apiService } from '../../services/api'
import { useApi } from '../../hooks/useApi'
import LoadingSpinner from '../LoadingSpinner'

const InformasiSection = () => {
  const { data: informasiData, loading, error } = useApi(apiService.getInformasi)

  if (loading) {
    return (
      <section id="informasi" className="section-padding bg-white">
        <div className="container-custom">
          <LoadingSpinner size="lg" text="Memuat informasi..." />
        </div>
      </section>
    )
  }

  if (error || !informasiData) {
    return (
      <section id="informasi" className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center">
            <i className="fas fa-exclamation-circle text-4xl text-gray-400 mb-4"></i>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Data Tidak Tersedia</h3>
            <p className="text-gray-600">Informasi belum tersedia saat ini.</p>
            <p className="opacity-75">Tunggu 1 menit dan refresh halaman. Terima kasih </p>
            <p className="opacity-75">-Admin</p>
          </div>
        </div>
      </section>
    )
  }

  const informasi = informasiData.informasi

  return (
    <section id="informasi" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <div className="mb-12">
            <div className="inline-flex items-center justify-center heading-circle-icon bg-primary-100 rounded-full mb-6">
              <i className="fas fa-info-circle heading-icon text-primary-600"></i>
            </div>
            <h2 className="heading-primary">{informasi.InformasiJudul||"Informasi"}</h2>
            <p className="text-body max-w-3xl mx-auto mb-8">{informasi.InformasiDeskripsi}</p>
          </div>

          {/* CTA Button */}
          {informasi.InformasiLink && (
            <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-8 text-white">
              <div className="mb-6">
                <i className="fas fa-bullhorn lg:text-4xl text-xl mb-4 opacity-90"></i>
                <h3 className="lg:text-2xl text-base font-bold mb-2">Pengumuman Penting</h3>
                <p className="opacity-90 lg:text-lg text-">Klik tombol di bawah untuk melihat informasi terbaru</p>
              </div>
              <div className='flex justify-center space-x-4'>
              <a
                href="/pendaftaran"
                target="_self"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center lg:px-8 px-2 lg:py-4 py-1 bg-white text-primary-600 lg:text-lg text-xs font-semibold rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fas fa-external-link-alt mr-2"></i>
                Pendaftaran 
              </a>
              
              <a
                href="/pengumuman"
                target="_self"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center lg:px-8 px-2 lg:py-4 py-1 bg-white text-primary-600 lg:text-lg text-xs font-semibold rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fas fa-external-link-alt mr-2"></i>
                Lihat Pengumuman
              </a>
              </div>
            </div>
          )}

          {/* No Link State */}
          {!informasi.InformasiLink && (
            <div className="bg-gray-100 rounded-2xl p-8">
              <i className="fas fa-clock text-4xl text-gray-400 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Segera Hadir</h3>
              <p className="text-gray-600">Pengumuman akan segera tersedia.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default memo(InformasiSection)